import React, { Component } from 'react';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import { Provider } from 'react-redux';
import { createReduxStore } from '../../redux/store';
import { type IPayAppComponentProps } from '../../types/PayApp';
import { globals } from '../../utils/globals';
import { initI18n } from '../../utils/i18n';
import { Panorama } from '../../utils/panorama';
import { InteractionName } from '../../types/InteractionName';
import { buildPropsFromEnv } from './buildPropsFromEnv';
import CashierPayAppComponent from './PayAppComponent.connect';

export class PayApp extends Component {
  private readonly builtProps: IPayAppComponentProps = buildPropsFromEnv();
  private store = createReduxStore();

  constructor(props) {
    super(props);
    Panorama.client?.reportLoadStart();
    Panorama.client?.transaction(InteractionName.ALE_LOADER).start();
  }

  UNSAFE_componentWillMount() {
    initI18n(globals.l10n, globals.locale);
  }

  componentWillUnmount(): void {
    Panorama.destroy();
  }

  componentDidCatch(error: Error): void {
    Panorama.errorMonitor?.reportError(error);
  }

  render() {
    return (
      <ExperimentsProvider options={{ experiments: globals.experiments }}>
        <Provider store={this.store}>
          <CashierPayAppComponent {...this.builtProps} />
        </Provider>
      </ExperimentsProvider>
    );
  }
}
